module.exports = __webpack_public_path__ + "static/img/1.4ff719a.png";


//////////////////
// WEBPACK FOOTER
// ./static/templates/sotet-konyha/layers/1.png
// module id = 857
// module chunks = 0